import root from 'window-or-global';

import {populateTemplate} from '../../components/creativeMode/islands/utils';

export const getIslandPageMetaTags = (
  localizationStore: LocalizationContextType,
  shareImageUrl: string,
  titleTemplate: string,
  descriptionTemplate: string,
  ogTitleTemplate: string,
  title: string,
  tagline: string,
  code: string,
  owner: string,
  twitterSite: string,
  locale = 'en-US'
) => {
  const transformedLocal = locale.replace('-', '_');
  // Social metadata
  const params = {code, title, owner};
  const metaTitle = populateTemplate(titleTemplate || title, params);
  const ogTitle = populateTemplate(ogTitleTemplate || metaTitle, params);
  const description =
    tagline || localizationStore.messages['epic.creative-mode.social.meta.site_description'];
  const metaDescription = populateTemplate(descriptionTemplate || description, params);
  const tags = {
    title: metaTitle,
    meta: [
      // SEO keywords
      {name: 'description', content: metaDescription},

      //Facebook
      {property: 'og:url', content: root.location.origin + root.location.pathname},
      {property: 'og:title', content: ogTitle},
      {property: 'og:description', content: metaDescription},
      {
        property: 'og:site_name',
        content: localizationStore.messages['epic.fortnite.social.meta.site_name'],
      },
      {property: 'og:locale', content: transformedLocal},
      {property: 'og:image', content: shareImageUrl},

      //Twitter
      {name: 'twitter:card', content: 'summary_large_image'},
      {
        name: 'twitter:site',
        content:
          twitterSite || localizationStore.messages['epic.fortnite.social.meta.twitter_account'],
      },
      {name: 'twitter:title', content: ogTitle},
      {name: 'twitter:description', content: `${tagline}`},
      {name: 'twitter:image', content: shareImageUrl},
    ],
  };
  if (locale !== 'en-US') {
    // Currently island pages do not have translations for the island names. Until this happens, noindex non English pages.
    tags.meta.push({name: 'robots', content: 'noindex,follow'});
  }
  return tags;
};
